var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Close, CurrencyRupee } from '@mui/icons-material';
import { Box, Chip, Stack, useMediaQuery } from '@mui/material';
import { useState } from 'react';
import { CustomerCardEditIcon, DropDownIconNew } from '../../../assets/customIcons';
import { ReactComponent as LocationIcon } from '../../../assets/images/LocationIcon.svg';
import { ReactComponent as CheckSvg } from '../../../assets/images/checkSvg.svg';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import { useAppDispatch } from '../../../store/hooks';
import { getStatusColor } from '../../../theme/statusColors';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { MailIconSVG } from '../../spareParts/purchaseRequistion/assets/customIcons';
import { CSRPostingTypes } from '../services/entity';
import ContractDetails from './contractDetails';
var GeneralTab = function () {
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var _b = useState(false), isReturn = _b[0], setIsReturn = _b[1];
    var dispatch = useAppDispatch();
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var handleCloseReturnClicked = function () {
        setIsReturn(true);
    };
    var formData = [
        // {
        //     type: FormItemTypes.ContainerItem,
        //     name: '',
        //     columnSize: 12,
        //     spacing: 0,
        //     width: 'auto',
        //     sx: {
        //         overflowX: 'auto',
        //         overflowY: 'visible',
        //         flexWrap: 'nowrap',
        //         width: '100%',
        //         scrollbarWidth: 'none'
        //     },
        //     position: 'static',
        //     elements: [
        //         {
        //             type: FormItemTypes.CardComponent,
        //             name: '',
        //             columnSize: 0,
        //             sx: {
        //                 padding: '6px',
        //                 bgcolor: 'secondary.100',
        //                 borderColor: 'secondary.200',
        //             },
        //             elements: [
        //                 {
        //                     type: FormItemTypes.Button,
        //                     label: '',
        //                     name: CSRPostingTypes.Paid,
        //                     columnSize: 0,
        //                     variant: 'text',
        //                     color: 'secondary',
        //                     size: 'small',
        //                     setFormState: async (state, val, field) => {
        //                         return {
        //                             SelectedButton: field.name
        //                         }
        //                     },
        //                     setFieldProps(state, value) {
        //                         return (
        //                             {
        //                                 type: FormItemTypes.Button,
        //                                 variant: state?.SelectedButton === this.name ? 'outlined' : 'text',
        //                                 color: 'secondary',
        //                                 sx: {
        //                                     fontWeight: 'strong',
        //                                     color: state?.SelectedButton === this.name ? 'text.primary' : undefined,
        //                                     bgcolor: state?.SelectedButton === this.name ? 'white' : "secondary.100",
        //                                 },
        //                                 children: [
        //                                     'MH12XC0158',
        //                                     <Chip
        //                                         variant='filled'
        //                                         size='small'
        //                                         color='secondary'
        //                                         sx={{
        //                                             fontWeight: 'medium',
        //                                             color: 'text.primary',
        //                                         }}
        //                                         label={state?.PaidAmount ?? 0}
        //                                     />
        //                                 ],
        //                             })
        //                     }
        //                 },
        //                 {
        //                     type: FormItemTypes.Button,
        //                     label: '',
        //                     name: CSRPostingTypes.Expenses,
        //                     columnSize: 0,
        //                     variant: 'text',
        //                     color: 'secondary',
        //                     size: 'small',
        //                     fullWidth: true,
        //                     setFormState: async (state, val, field) => {
        //                         return {
        //                             SelectedButton: field.name
        //                         }
        //                     },
        //                     setFieldProps(state, value) {
        //                         return (
        //                             {
        //                                 type: FormItemTypes.Button,
        //                                 variant: state?.SelectedButton === this.name ? 'outlined' : 'text',
        //                                 color: 'secondary',
        //                                 sx: {
        //                                     fontWeight: 'strong',
        //                                     color: state?.SelectedButton === this.name ? 'text.primary' : undefined,
        //                                     bgcolor: state?.SelectedButton === this.name ? 'white' : "secondary.100",
        //                                 },
        //                                 children: [
        //                                     'MH12TM5363',
        //                                     <Chip
        //                                         variant='filled'
        //                                         size='small'
        //                                         color='secondary'
        //                                         sx={{
        //                                             fontWeight: 'medium',
        //                                             color: 'text.primary',
        //                                         }}
        //                                         label={state?.ExpenseAmount ?? 0}
        //                                     />
        //                                 ],
        //                             })
        //                     }
        //                 },
        //                 {
        //                     type: FormItemTypes.Button,
        //                     label: '',
        //                     name: CSRPostingTypes.Claims,
        //                     columnSize: 0,
        //                     variant: 'text',
        //                     color: 'secondary',
        //                     size: 'small',
        //                     fullWidth: true,
        //                     setFormState: async (state, val, field) => {
        //                         return {
        //                             SelectedButton: field.name
        //                         }
        //                     },
        //                     setFieldProps(state, value) {
        //                         return (
        //                             {
        //                                 type: FormItemTypes.Button,
        //                                 variant: state?.SelectedButton === this.name ? 'outlined' : 'text',
        //                                 color: 'secondary',
        //                                 sx: {
        //                                     fontWeight: 'strong',
        //                                     color: state?.SelectedButton === this.name ? 'text.primary' : undefined,
        //                                     bgcolor: state?.SelectedButton === this.name ? 'white' : "secondary.100",
        //                                 },
        //                                 children: [
        //                                     'MH12B9480',
        //                                     <Chip
        //                                         variant='filled'
        //                                         size='small'
        //                                         color='secondary'
        //                                         sx={{
        //                                             fontWeight: 'medium',
        //                                             color: 'text.primary',
        //                                         }}
        //                                         label={state?.ClaimAmount ?? 0}
        //                                     />
        //                                 ],
        //                             })
        //                     }
        //                 },
        //             ],
        //         },
        //     ]
        // },
        {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            sx: {
                overflow: 'scroll'
            },
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    columnSize: 0,
                    display: 'flex',
                    bgcolor: '#FFFFFF',
                    padding: '8px',
                    gap: '20px',
                    alignItems: 'center',
                    borderRadius: '8px',
                    setFieldProps: function (state) { return ({
                        type: FormItemTypes.Box,
                        name: '',
                        elements: CSRPostingTypes.map(function (data, index) {
                            var _state$VehicleContrac, _state$VehicleContrac2;
                            return {
                                type: FormItemTypes.Box,
                                name: 'vehicleNumber',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                columnSize: 0,
                                borderRfadius: '8px',
                                padding: '6px 12px',
                                setFieldProps: function (state, value) {
                                    return {
                                        type: FormItemTypes.Box,
                                        bgcolor: (state === null || state === void 0 ? void 0 : state.selectedVehicle) === (data === null || data === void 0 ? void 0 : data.RegistrationNo) ? '#EFF2F5' : 'transparent'
                                    };
                                },
                                elements: [{
                                        type: FormItemTypes.CheckBox,
                                        label: '',
                                        name: "vehicle-".concat(data === null || data === void 0 ? void 0 : data.RegNo),
                                        columnSize: 0,
                                        sx: {
                                            padding: 0
                                        },
                                        formControlLabelProps: {
                                            sx: {
                                                margin: 0
                                            }
                                        }
                                    }, {
                                        type: FormItemTypes.Button,
                                        name: '',
                                        variant: 'text',
                                        children: "MH12XC0158",
                                        color: 'info',
                                        columnSize: 0,
                                        sx: {
                                            p: 0,
                                            gap: '20px',
                                            color: '#1B1D21'
                                        },
                                        endIcon: /*#__PURE__*/ React.createElement(Stack, null, (state === null || state === void 0 || (_state$VehicleContrac = state.VehicleContractDetails) === null || _state$VehicleContrac === void 0 || (_state$VehicleContrac = _state$VehicleContrac.find(function (contract) { return (contract === null || contract === void 0 ? void 0 : contract.RegistrationNo) === (data === null || data === void 0 ? void 0 : data.RegistrationNo); })) === null || _state$VehicleContrac === void 0 || (_state$VehicleContrac = _state$VehicleContrac.items) === null || _state$VehicleContrac === void 0 ? void 0 : _state$VehicleContrac.length) > 0 && /*#__PURE__*/ React.createElement(Chip, {
                                            color: "secondary",
                                            label: (state === null || state === void 0 || (_state$VehicleContrac2 = state.VehicleContractDetails) === null || _state$VehicleContrac2 === void 0 || (_state$VehicleContrac2 = _state$VehicleContrac2.find(function (contract) { return (contract === null || contract === void 0 ? void 0 : contract.RegistrationNo) === (data === null || data === void 0 ? void 0 : data.RegistrationNo); })) === null || _state$VehicleContrac2 === void 0 || (_state$VehicleContrac2 = _state$VehicleContrac2.items) === null || _state$VehicleContrac2 === void 0 ? void 0 : _state$VehicleContrac2.length) || 0
                                        }))
                                    }]
                            };
                        })
                    }); }
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.CardComponent,
                    name: '',
                    columnSize: 12,
                    sx: {
                        border: '1px',
                        borderRadius: "12px",
                        borderColor: "secondary.200"
                    },
                    setFormState: function (formValues, currValue) {
                        return {};
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: true,
                            fontWeight: "strong",
                            children: 'Basic details',
                            color: "secondary.900"
                        }, {
                            type: FormItemTypes.IconButton,
                            name: '',
                            columnSize: 0,
                            children: /*#__PURE__*/ React.createElement(DropDownIconNew, null),
                            setFormState: function (formValues, currValue) {
                                if (isOpen) {
                                    setIsOpen(false);
                                }
                                else {
                                    setIsOpen(true);
                                }
                                return {};
                            }
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            spacing: 0,
                            rowGap: 1,
                            columnSpacing: 2,
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    xs: 12,
                                    sm: 6,
                                    md: 4,
                                    spacing: 1,
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            children: 'Customer details',
                                            fontSize: 'sm',
                                            fontWeight: 'medium',
                                            color: 'text.secondary',
                                            columnSize: 12
                                        }, !isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: '',
                                            sx: {
                                                p: 1.5
                                            },
                                            columnSize: 12,
                                            contentProps: {
                                                spacing: 0
                                            },
                                            elements: [{
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 12,
                                                    spacing: 0,
                                                    columnGap: 1,
                                                    alignItems: 'center',
                                                    flexWrap: 'nowrap',
                                                    elements: [{
                                                            type: FormItemTypes.Avatar,
                                                            name: '',
                                                            columnSize: 0,
                                                            sx: {
                                                                height: 24,
                                                                width: 24
                                                            }
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: '',
                                                            columnSize: 0,
                                                            children: "reya raheja",
                                                            fontWeight: 'medium'
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: '',
                                                            columnSize: true,
                                                            value: "9998398908",
                                                            fontSize: "sm",
                                                            color: 'text.secondary'
                                                        }, {
                                                            type: FormItemTypes.IconButton,
                                                            name: '',
                                                            children: /*#__PURE__*/ React.createElement(CustomerCardEditIcon, {
                                                                color: "secondary"
                                                            }),
                                                            columnSize: 0,
                                                            color: 'secondary'
                                                        }]
                                                }]
                                        } : null, isOpen ? {
                                            type: FormItemTypes.Box,
                                            label: '',
                                            name: '',
                                            value: null,
                                            columnSize: 12,
                                            margin: 0,
                                            sx: {
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '8px',
                                                border: '1px solid ',
                                                paddingY: '16px',
                                                borderRadius: '12px',
                                                borderColor: "secondary.200"
                                            },
                                            elements: [{
                                                    type: FormItemTypes.Box,
                                                    name: '',
                                                    display: 'flex',
                                                    columnSize: 12,
                                                    paddingInline: '16px',
                                                    gap: '8px',
                                                    elements: [{
                                                            type: FormItemTypes.Avatar,
                                                            name: '',
                                                            columnSize: 0
                                                        }, {
                                                            type: FormItemTypes.Box,
                                                            name: '',
                                                            columnSize: 12,
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            gap: '4px',
                                                            elements: [{
                                                                    type: FormItemTypes.Box,
                                                                    name: '',
                                                                    display: 'flex',
                                                                    columnSize: 12,
                                                                    sx: {
                                                                        justifyContent: 'space-between'
                                                                    },
                                                                    height: '20px',
                                                                    elements: [{
                                                                            type: FormItemTypes.Typography,
                                                                            name: '',
                                                                            value: 'Riya Raheja',
                                                                            columnSize: true,
                                                                            fontWeight: 'medium'
                                                                        }, {
                                                                            type: FormItemTypes.Icon,
                                                                            name: '',
                                                                            children: /*#__PURE__*/ React.createElement(CustomerCardEditIcon, {
                                                                                color: "secondary"
                                                                            }),
                                                                            columnSize: 0,
                                                                            sx: {
                                                                                cursor: 'pointer',
                                                                                height: '20px',
                                                                                width: '20px'
                                                                            }
                                                                        }]
                                                                }, {
                                                                    type: FormItemTypes.Box,
                                                                    name: '',
                                                                    display: 'flex',
                                                                    columnSize: 12,
                                                                    gap: '8px',
                                                                    height: '18px',
                                                                    elements: [{
                                                                            type: FormItemTypes.Box,
                                                                            name: '',
                                                                            display: 'flex',
                                                                            columnSize: 0,
                                                                            gap: '4px',
                                                                            elements: [{
                                                                                    type: FormItemTypes.Typography,
                                                                                    name: '',
                                                                                    columnSize: 0,
                                                                                    value: '90875205812',
                                                                                    fontSize: 'sm',
                                                                                    fontWeight: 'normal',
                                                                                    color: "secondary.500"
                                                                                }]
                                                                        }, {
                                                                            type: FormItemTypes.Divider,
                                                                            name: 'name',
                                                                            variant: 'fullWidth',
                                                                            orientation: 'vertical',
                                                                            columnSize: 0
                                                                        }, {
                                                                            type: FormItemTypes.Box,
                                                                            name: '',
                                                                            display: 'flex',
                                                                            columnSize: 0,
                                                                            gap: '4px',
                                                                            elements: [{
                                                                                    type: FormItemTypes.Typography,
                                                                                    name: '',
                                                                                    columnSize: 0,
                                                                                    value: '90875205812',
                                                                                    fontSize: 'sm',
                                                                                    fontWeight: 'normal',
                                                                                    color: "secondary.500"
                                                                                }, {
                                                                                    type: FormItemTypes.Icon,
                                                                                    name: '',
                                                                                    columnSize: 0,
                                                                                    sx: {
                                                                                        p: 0,
                                                                                        mt: '2px'
                                                                                    }
                                                                                }]
                                                                        }]
                                                                }]
                                                        }]
                                                }, {
                                                    type: FormItemTypes.Box,
                                                    name: '',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    columnSize: 12,
                                                    paddingInline: '16px',
                                                    gap: '8px',
                                                    elements: [{
                                                            type: FormItemTypes.Box,
                                                            name: '',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            columnSize: 12,
                                                            gap: '8px',
                                                            elements: [{
                                                                    type: FormItemTypes.Box,
                                                                    name: '',
                                                                    display: 'flex',
                                                                    columnSize: 12,
                                                                    gap: '8px',
                                                                    alignItems: 'center',
                                                                    elements: [{
                                                                            type: FormItemTypes.IconButton,
                                                                            name: '',
                                                                            children: /*#__PURE__*/ React.createElement(MailIconSVG, null),
                                                                            columnSize: 0,
                                                                            sx: {
                                                                                color: "secondary.500",
                                                                                paddingInline: 0
                                                                            }
                                                                        }, {
                                                                            type: FormItemTypes.Typography,
                                                                            name: '',
                                                                            columnSize: true,
                                                                            value: 'riyaraheja@gmail.com',
                                                                            fontSize: 'sm',
                                                                            fontWeight: 'normal'
                                                                        }]
                                                                }, {
                                                                    type: FormItemTypes.Box,
                                                                    name: '',
                                                                    display: 'flex',
                                                                    columnSize: 12,
                                                                    gap: '8px',
                                                                    alignItems: 'center',
                                                                    elements: [{
                                                                            type: FormItemTypes.IconButton,
                                                                            name: '',
                                                                            children: /*#__PURE__*/ React.createElement(LocationIcon, null),
                                                                            columnSize: 0,
                                                                            sx: {
                                                                                paddingInline: 0
                                                                            }
                                                                        }, {
                                                                            type: FormItemTypes.Typography,
                                                                            name: '',
                                                                            columnSize: true,
                                                                            value: 'Ganga Home, Row House No.1/2, next to Bank of India, Viman Nagar, Pune,',
                                                                            color: " secondary.500",
                                                                            fontSize: 'sm',
                                                                            fontWeight: 'normal'
                                                                        }]
                                                                }]
                                                        }]
                                                }]
                                        } : null]
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    xs: 12,
                                    sm: 6,
                                    md: 4,
                                    spacing: 1,
                                    elements: [{
                                            type: FormItemTypes.ContainerItem,
                                            name: 'BasicDetails',
                                            justifyContent: 'space-between',
                                            columnSize: 12,
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    children: 'Vehicle details',
                                                    fontSize: 'sm',
                                                    fontWeight: 'medium',
                                                    color: 'text.secondary',
                                                    columnSize: 0
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    children: 'Vehicle history',
                                                    fontSize: 'sm',
                                                    fontWeight: 'medium',
                                                    color: 'primary.main',
                                                    columnSize: 0,
                                                    sx: {
                                                        cursor: 'pointer'
                                                    }
                                                }]
                                        }, !isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: '',
                                            columnSize: 12,
                                            contentProps: {
                                                justifyContent: "space-between",
                                                spacing: 0
                                            },
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    columnSize: 0,
                                                    children: "MH12PY0987",
                                                    fontWeight: 'medium'
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    columnSize: 0,
                                                    value: "Bajaj RE CNG 4S Fi (00AF21)",
                                                    fontSize: "sm",
                                                    color: 'text.secondary'
                                                }]
                                        } : null, isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: '',
                                            columnSize: 12,
                                            contentProps: {
                                                spacing: 0,
                                                rowGap: 1
                                            },
                                            elements: [{
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 12,
                                                    spacing: 0,
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: '',
                                                            columnSize: 12,
                                                            children: "MH12PY0987",
                                                            fontWeight: 'medium'
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: '',
                                                            columnSize: 12,
                                                            value: "Bajaj RE CNG 4S Fi (00AF21)",
                                                            fontSize: "sm",
                                                            color: 'text.secondary'
                                                        }]
                                                }, {
                                                    type: FormItemTypes.CardComponent,
                                                    name: 'Vehicle details',
                                                    columnSize: 12,
                                                    sx: {
                                                        bgcolor: "secondary.50",
                                                        border: "none",
                                                        px: 1.5,
                                                        py: 1
                                                    },
                                                    contentProps: {
                                                        spacing: 0
                                                    },
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: 'Engine no.:',
                                                            label: 'Engine no:',
                                                            value: 'AZXWME51553',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'Chassis no.:',
                                                            label: 'Chassis no.:',
                                                            value: 'MD2DDDZZZMWL36200',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'Date of sale:',
                                                            label: 'Date of sale:',
                                                            value: '27-01-2023',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }]
                                                }]
                                        } : null]
                                }]
                        }]
                }]
        }, {
            type: FormItemTypes.CardComponent,
            name: '',
            label: 'Contract details',
            value: null,
            columnSize: 12,
            containerProps: {
                spacing: 0
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: 'data',
                    columnSize: 12,
                    spacing: 0,
                    gap: '20px',
                    elements: Array.from({
                        length: 3
                    }).map(function (formValues, index) { return (console.log('formValues', formValues), console.log('index', index), {
                        type: FormItemTypes.Box,
                        name: '',
                        width: '303px',
                        border: '1px solid',
                        borderRadius: '12px',
                        sx: {
                            position: 'absolute'
                        },
                        setFieldProps: function (formValues, currValue) {
                            var _formValues$contractD;
                            return {
                                type: this.type,
                                value: null,
                                sx: {
                                    borderColor: (formValues === null || formValues === void 0 || (_formValues$contractD = formValues.contractDetails) === null || _formValues$contractD === void 0 ? void 0 : _formValues$contractD.isAdded) == true ? 'red' : '#DEE4EB'
                                }
                            };
                        },
                        elements: [{
                                type: FormItemTypes.Icon,
                                name: '',
                                children: /*#__PURE__*/ React.createElement(CheckSvg, {
                                    height: 24,
                                    width: 24,
                                    color: "#EB6A2C"
                                }),
                                columnSize: 12,
                                sx: {
                                    display: 'flex',
                                    justifyContent: 'end',
                                    position: 'relative',
                                    right: -285,
                                    top: 0
                                },
                                setFieldProps: function (formValues) {
                                    var _formValues$contractD2;
                                    return {
                                        type: FormItemTypes.Icon,
                                        sx: {
                                            // display: 'flex',
                                            display: (formValues === null || formValues === void 0 || (_formValues$contractD2 = formValues.contractDetails) === null || _formValues$contractD2 === void 0 ? void 0 : _formValues$contractD2.isAdded) == true ? 'flex' : 'none',
                                            justifyContent: 'end',
                                            position: 'relative',
                                            right: -285,
                                            top: -10
                                        }
                                    };
                                }
                            }, {
                                type: FormItemTypes.Icon,
                                name: '',
                                children: /*#__PURE__*/ React.createElement(CurrencyRupee, {
                                    height: 2,
                                    width: 2
                                }),
                                columnSize: 12,
                                sx: {
                                    display: 'flex',
                                    justifyContent: 'end',
                                    position: 'absolute',
                                    right: -10,
                                    top: -10
                                }
                            }, {
                                type: FormItemTypes.ContainerItem,
                                name: '',
                                columnSize: 12,
                                spacing: 0,
                                padding: '16px',
                                gap: '16px',
                                elements: [{
                                        type: FormItemTypes.ContainerItem,
                                        name: '',
                                        columnSize: 12,
                                        spacing: 0,
                                        elements: [{
                                                type: FormItemTypes.ContainerItem,
                                                name: '',
                                                spacing: 0,
                                                columnSize: 12,
                                                justifyContent: 'space-between',
                                                elements: [{
                                                        type: FormItemTypes.Typography,
                                                        name: '',
                                                        value: '#CNT-2025-002',
                                                        columnSize: 0,
                                                        fontSize: 'sm',
                                                        fontWeight: 'medium',
                                                        color: '#6A7682'
                                                    }, {
                                                        type: FormItemTypes.Chip,
                                                        name: '',
                                                        label: 'Active',
                                                        size: 'small',
                                                        color: getStatusColor('New').color,
                                                        columnSize: 0,
                                                        sx: {
                                                            borderRadius: '6px'
                                                        }
                                                    }]
                                            }, {
                                                type: FormItemTypes.Typography,
                                                name: '',
                                                value: 'Service AMC plan for 2 years Roadside Assistance',
                                                columnSize: 12,
                                                fontSize: 'lg',
                                                fontWeight: 'medium'
                                            }]
                                    }, {
                                        type: FormItemTypes.ContainerItem,
                                        name: '',
                                        columnSize: 12,
                                        spacing: 0,
                                        bgcolor: '#FFF7F0',
                                        borderRadius: '8px',
                                        padding: '12px',
                                        gap: '8px',
                                        elements: [{
                                                type: FormItemTypes.Typography,
                                                name: 'EffectiveFrom',
                                                label: 'Effective from:',
                                                value: '12 Aug, 2023',
                                                containerProps: {
                                                    display: 'inline-flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'baseline',
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: 'medium',
                                                    fontSize: 'sm'
                                                },
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                columnSize: 12
                                            }, {
                                                type: FormItemTypes.ContainerItem,
                                                name: '',
                                                columnSize: 12,
                                                spacing: 0,
                                                elements: [{
                                                        type: FormItemTypes.Typography,
                                                        name: 'sdas',
                                                        label: 'Effective from:',
                                                        value: '12 Aug, 2023',
                                                        containerProps: {
                                                            display: 'inline-flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'baseline',
                                                            gap: 1
                                                        },
                                                        labelTypographyProps: {
                                                            mb: 0,
                                                            noWrap: true,
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm'
                                                        },
                                                        fontWeight: 'medium',
                                                        fontSize: 'sm',
                                                        columnSize: 12
                                                    }]
                                            }]
                                    }]
                            }, {
                                type: FormItemTypes.ContainerItem,
                                name: '',
                                columnSize: 12,
                                spacing: 0,
                                padding: '12px 16px 16px 16px',
                                borderRadius: '0 0 12px 12px',
                                gap: '20px',
                                bgcolor: '#EEF6FF',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                elements: [{
                                        type: FormItemTypes.ContainerItem,
                                        name: '',
                                        columnSize: 6,
                                        spacing: 0,
                                        direction: 'column',
                                        elements: [{
                                                type: FormItemTypes.Typography,
                                                name: '',
                                                value: '₹ 27,097.00',
                                                fontSize: 'lg',
                                                fontWeight: 'strong',
                                                columnSize: 0
                                            }]
                                    }, {
                                        type: FormItemTypes.Button,
                                        name: '',
                                        variant: 'contained',
                                        children: 'Return',
                                        size: 'small',
                                        columnSize: 0,
                                        // onClick: handleReturnClicked,
                                        setFieldProps: function (formValues, currValue) {
                                            var _formValues$contractD3, _formValues$contractD4;
                                            console.log(' formValues----Setfield----', formValues === null || formValues === void 0 || (_formValues$contractD3 = formValues.contractDetails) === null || _formValues$contractD3 === void 0 ? void 0 : _formValues$contractD3.isAdded);
                                            return {
                                                type: this.type,
                                                value: null,
                                                sx: {
                                                    display: (formValues === null || formValues === void 0 || (_formValues$contractD4 = formValues.contractDetails) === null || _formValues$contractD4 === void 0 ? void 0 : _formValues$contractD4.isAdded) == true ? 'none' : 'flex'
                                                }
                                            };
                                        },
                                        setFormState: function () { return __awaiter(void 0, void 0, void 0, function () {
                                            var data, error_1;
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0:
                                                        _a.trys.push([0, 2, , 3]);
                                                        return [4 /*yield*/, dispatch(showSurface({
                                                                type: 'Drawer',
                                                                Component: ContractDetails,
                                                                containerProps: {
                                                                    PaperProps: {
                                                                        sx: {
                                                                            width: {
                                                                                xs: '100%',
                                                                                sm: '350px'
                                                                            }
                                                                        }
                                                                    },
                                                                    anchor: isMobile ? 'bottom' : 'right'
                                                                }
                                                            }))];
                                                    case 1:
                                                        data = _a.sent();
                                                        return [2 /*return*/, {
                                                                contractDetails: (data === null || data === void 0 ? void 0 : data.payload) || null
                                                            }];
                                                    case 2:
                                                        error_1 = _a.sent();
                                                        console.error('Error setting form state:', error_1);
                                                        return [2 /*return*/, {
                                                                contractDetails: null
                                                            }];
                                                    case 3: return [2 /*return*/];
                                                }
                                            });
                                        }); }
                                    }, {
                                        type: FormItemTypes.ContainerItem,
                                        name: 'isReturn',
                                        columnSize: 4.2,
                                        spacing: 0,
                                        flexDirection: 'row',
                                        justifyContent: 'end',
                                        gap: '16px',
                                        setFieldProps: function (formValues, currValue) {
                                            var _formValues$contractD5, _formValues$contractD6;
                                            console.log('Inside the setFormState----', formValues === null || formValues === void 0 || (_formValues$contractD5 = formValues.contractDetails) === null || _formValues$contractD5 === void 0 ? void 0 : _formValues$contractD5.isAdded);
                                            return {
                                                type: this.type,
                                                value: null,
                                                sx: {
                                                    display: (formValues === null || formValues === void 0 || (_formValues$contractD6 = formValues.contractDetails) === null || _formValues$contractD6 === void 0 ? void 0 : _formValues$contractD6.isAdded) == true ? 'flex' : 'none'
                                                }
                                            };
                                        },
                                        elements: [{
                                                type: FormItemTypes.Button,
                                                name: '',
                                                children: /*#__PURE__*/ React.createElement(CustomerCardEditIcon, null),
                                                columnSize: 0,
                                                color: 'secondary',
                                                variant: 'outlined',
                                                sx: {
                                                    padding: '8px'
                                                },
                                                setFieldProps: function (formValues, currValue) {
                                                    return {
                                                        type: this.type,
                                                        display: null
                                                    };
                                                },
                                                onClick: function () {
                                                    dispatch(showSurface({
                                                        type: 'Drawer',
                                                        Component: ContractDetails,
                                                        containerProps: {
                                                            PaperProps: {
                                                                sx: {
                                                                    width: {
                                                                        xs: '100%',
                                                                        sm: '350px'
                                                                    }
                                                                }
                                                            },
                                                            anchor: isMobile ? 'bottom' : 'right'
                                                        }
                                                    }));
                                                }
                                            }, {
                                                type: FormItemTypes.Button,
                                                name: 'close',
                                                children: /*#__PURE__*/ React.createElement(Close, {
                                                    height: 2,
                                                    width: 2
                                                }),
                                                columnSize: 0,
                                                color: 'primary',
                                                variant: 'outlined',
                                                sx: {
                                                    padding: '8px'
                                                },
                                                onClick: handleCloseReturnClicked,
                                                setFormState: function (formValue) {
                                                    console.log('----- Close--SetFieldProps----', formValue);
                                                    return {
                                                        isAdded: false
                                                    };
                                                }
                                            }]
                                    }]
                            }]
                    }); })
                }]
        }
    ];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            padding: 2
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData
    })));
};
export default GeneralTab;
